import { memo } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';


const BzTabsContainer = ({ className, children, ...props }) => {
    return (   
        <Container fluid className='p-0'>
            <Row className='g-0'>
                <Col>
                    <div className={`tab-content ${className}`} {...props}>
                        {children}
                    </div>       
                </Col>
            </Row>
        </Container>             
    )
}

BzTabsContainer.propTypes = {
    className: PropTypes.string,
}

BzTabsContainer.defaultProps = {
    className: ""
}


export default memo(BzTabsContainer)
